import { BaseSkeletonGroupProps } from "./types";

const BaseSkeletonGroup = ({
  label,
  className,
  children,
}: BaseSkeletonGroupProps) => (
  <div role="status" aria-busy="true" aria-label={label} className={className}>
    {children}
  </div>
);

export default BaseSkeletonGroup;
